import { Component } from "react";
import { Loader2, TriangleAlert } from "lucide-react";

const italian = () => localStorage.getItem("iagora_lang") !== "en";

export const AppLoading = ({ label }) => <div className="min-h-[50vh] flex items-center justify-center gap-3 p-8 text-slate-200" role="status" aria-live="polite" data-testid="app-loading">
  <Loader2 className="h-5 w-5 animate-spin text-indigo-400" /><span>{label || (italian() ? "Caricamento del tuo studio…" : "Loading your studio…")}</span>
</div>;

export class AppErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidUpdate(previous) {
    if (this.state.failed && previous.resetKey !== this.props.resetKey) this.setState({ failed: false });
  }
  componentDidCatch(error) { console.error("Page rendering failed", error); }
  render() {
    if (!this.state.failed) return this.props.children;
    return <div className="m-6 rounded-lg border border-amber-400/30 bg-[#111118] p-8 text-slate-100" role="alert" data-testid="page-error-boundary">
      <TriangleAlert className="h-7 w-7 text-amber-300 mb-4" />
      <h1 className="font-display text-xl font-bold">{italian() ? "Questa pagina non si è caricata correttamente" : "This page could not be loaded"}</h1>
      <p className="mt-3 text-sm text-slate-400">{italian() ? "Puoi riprovare oppure tornare alla dashboard. I tuoi dati salvati non sono stati modificati." : "Retry or return to the dashboard. Your saved data has not changed."}</p>
      <div className="mt-6 flex flex-wrap gap-3">
        <button className="rounded-full bg-indigo-600 px-5 py-2 text-sm hover:bg-indigo-500 transition-colors" data-testid="page-error-retry" onClick={() => this.setState({ failed: false })}>{italian() ? "Riprova" : "Retry"}</button>
        <a className="rounded-full border border-white/15 px-5 py-2 text-sm hover:bg-white/5 transition-colors" data-testid="page-error-dashboard" href="/dashboard">Dashboard</a>
      </div>
    </div>;
  }
}
